import React, {useContext} from "react"
import Image from "next/image"
import DataContext from "../../../context/DataContext"
import {formatImageSrc} from "../../../strapi/strapiHelpers"

type Props = {
	isBackgroundAnimation?:boolean
}

const CircleAnimations = ({isBackgroundAnimation}: Props) => {
	const {brandWorld} = useContext(DataContext)
	if (brandWorld?.movingCircles?.data?.length === 3) {
		return (
			<div className={isBackgroundAnimation ? "background-CirclesContainer " : "brand-world-circles-container"}>
				<div className={isBackgroundAnimation ? "background-thirdCircle" : "thirdCircle"}>
					{brandWorld?.movingCircles?.data?.[1] ? <Image
						src={formatImageSrc(brandWorld?.movingCircles?.data?.[1]?.attributes?.url)}
						alt="Third Circle"
						width={600}
						height={770}
					/> : null}
				</div>

				<div className={isBackgroundAnimation ? "background-secondaryCircle" : "secondaryCircle"}>
					{brandWorld?.movingCircles?.data?.[2] ? <Image
						src={formatImageSrc(brandWorld?.movingCircles?.data?.[2]?.attributes?.url)}
						alt="Secondary Circle"
						width={670}
						height={823}
					/> : null}
				</div>

				<div className={isBackgroundAnimation ? "background-mainCircle" : "mainCircle"}>
					{brandWorld?.movingCircles?.data?.[0] ? <Image
						src={formatImageSrc(brandWorld?.movingCircles?.data?.[0]?.attributes?.url)}
						alt="Main Circle"
						width={720}
						height={875}
					/> : null}
				</div>
			</div>
		)
	}

	return <></>
}

export default CircleAnimations
